module.exports = __webpack_public_path__ + "img/maas_bg5.9266bdd6.png";